import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonWrapper } from "@insite/mobius/Button/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import { Hidden, Icon, LazyImage, Link, Modal, Typography } from "@insite/mobius/index";
import { LazyImageStyle } from "@insite/mobius/LazyImage/LazyImage";
import { ModalPresentationProps } from "@insite/mobius/Modal/Modal";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIXtenExportToXtenButton from "@NA/Components/ADIXtenExportToXtenButton";
import ADIChangePassword from "@NA/Components/ChangePassword/ADIChangePassword";
import ADIChangePasswordModalWrapper from "@NA/Components/ChangePassword/ADIChangePasswordModalWrapper";
import ADIPickUpNotification from "@NA/Components/PickUpNotification/ADIPickUpNotification";
import ADIPickUpNotificationModalWrapper from "@NA/Components/PickUpNotification/ADIPickUpNotificationModalWrapper";
import { IsXtenAllowedUser } from "@NA/Hooks/useAdiXtenIntegrationHelper";
import Billing from "@NA/Icons/MyAccount/Billing";
import Help from "@NA/Icons/MyAccount/Help";
import MyOrder from "@NA/Icons/MyAccount/MyOrder";
import MyQuotes from "@NA/Icons/MyAccount/MyQuotes";
import OrderingTools from "@NA/Icons/MyAccount/OrderingTools";
import PromoAndDeals from "@NA/Icons/MyAccount/PromoAndDeals";
import Returns from "@NA/Icons/MyAccount/Returns";
import Settings from "@NA/Icons/MyAccount/Settings";
import RewardsTooltipIcon from "@NA/Icons/RewardsTooltipIcon";
import RewardsTooltipIconForAcc from "@NA/Icons/RewardsTooltipIconForAcc";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import { containsPortNumber } from "@NA/Utils/Utility";

import React, { ComponentType, FC, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {
    const roles = state.context.session?.userRoles;
    const catalogSettings = state.context.settings.settingsCollection.catalogSettingSettings as any;
    const userRoles = state.ADIGlobalData.ADIUserRoleStore;
    const session = state.context.session;
    let customerNumber = "";
    const billToId = state.context.session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        roles,
        userRoles,
        customerNumber,
        catalogSettings,
        session,
    };

};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface ADIMyAccountStyles {
    myaccountGridContainer?: GridContainerProps;
    myaccountGridItem?: GridItemProps;
    leftcontent?: InjectableCss;
    leftContentHidden?: InjectableCss;
    leftContentIcon?: IconPresentationProps;
    leftContentTextWrapper?: InjectableCss;
    leftContentText?: InjectableCss;
    leftcontentMobile?: InjectableCss;
    leftContentIconMobile?: IconPresentationProps;
    leftContentTextWrapperMobile?: InjectableCss;
    leftContentTextMobile?: InjectableCss;
    rightcontent?: InjectableCss;
    rightContentLinkWrapper?: InjectableCss;
    rightContentLink?: InjectableCss;
    modal?: ModalPresentationProps;
}

export const adiMyAccountStyles: ADIMyAccountStyles = {
    myaccountGridContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin: 0;
            padding-top: 15px;
            margin-top: 20px;
            margin-bottom: 30px;
            > ${GridOffset} {
                width: 100% !important;
                margin: 0px !important;
                gap: 15px;
            }
        `,
    },
    myaccountGridItem: {
        css: css`
            background: ${ADIColors.white};
            margin-top: 25px;
            max-width: initial;
            border-radius: 6px;
            height: 173px;
			padding: 0px;	 
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        flex-direction: column;
                        height: auto;
                    `,
                    css`
                        display: flex;
                        flex-direction: column;
                        height: auto;
                    `,
                    css`
                        flex-basis: 48%;
                        max-width: 48%;
									 
                        height: 192px;		 
					  
                    `,
                    css`
                        flex-basis: 49%;
                        max-width: 49%;
                    `,
                    css`
                        flex-basis: 32.333333%;
                        max-width: 32.333333%;
                    `,
                ]);
            }}
        `,
    },
    leftcontent: {
        css: css`
            max-width: 162px;
            width: 162px;
            border-right: solid 2px ${ADIColors.gray7};
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0 10px;
            > ${TypographyStyle} {
                max-width: 162px;
                width: 162px;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 0 10px;
            }
			${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        max-width: 136px;
                        width: 136px;
                    `,
                    css`
                        max-width: 136px;
                        width: 136px;
                    `,
                    css`
                        max-width: 136px;
                        width: 136px;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    leftContentIcon: {
        size: 32,
    },
    leftContentTextWrapper: {
        css: css`
            display: flex;
            padding: 0 14px;
            margin-top: 12px;
            width: 100%;
            justify-content: center;
        `,
    },
    leftContentText: {
        css: css`
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            color: ${ADIColors.darkBlue1} !important;
			${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                    font-size: 18px;
                    line-height: 1.2;
                    `,
                    css`
                    font-size: 18px;
                    line-height: 1.2;
                    `,
                    css`
                    font-size: 18px;
                    line-height: 1.2;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    leftContentHidden: {
        css: css`
            height: 100%;

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        height: auto;
                    `,
                    css`
                        width: 100%;
                        height: auto;
                    `,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
    leftcontentMobile: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: solid 2px ${ADIColors.gray7};
            height: 100%;
            padding: 0 10px;
            padding-top: 14px;
            padding-bottom: 14px;
        `,
    },

    leftContentIconMobile: {
        size: 24,
    },
    leftContentTextWrapperMobile: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
        `,
    },
    leftContentTextMobile: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            line-height: normal;
            margin-left: 14px;
            color: ${ADIColors.darkBlue1} !important;
        `,
    },
    rightcontent: {
        css: css`
            display: flex;
            padding-left: 31px;
            padding-right: 15px;
            align-items: center;
            height: 173px;
			height: 100%;
            ul {
                margin-left: 0;
                margin-top: 0;
                margin-bottom: 0;
                li {
                    position: relative;
                    padding-bottom: 10px;
                    line-height: 0;
                    list-style-type: none;
                    &:last-child{
                        ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                                    padding-bottom: 0px;
                                `,
                    css`
                                    padding-bottom: 0px;
                                `,
                    css`
                                    padding-bottom: 0px;
                                `,

                ]);
            }}
                    }
                
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        height: 100%;
                        width: 100%;
                        padding: 0;
                        margin: 0;
                        ul {
                            margin-left: 0;
                            margin-top: 0;
                            margin-bottom: 0;
                            width: 100%;
                            li {
                                display: flex;
                                padding-top: 14px;
                                padding-bottom: 14px;
                                padding-left: 40px;
                                line-height: 0;
                                list-style-type: none;
                                border-bottom: solid 2px ${ADIColors.gray7};
                                ${TypographyStyle} {
                                    font-size: 14px;
                                    font-weight: 600;
                                }
                            }
                        }
                    `,
                    css`
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        height: 100%;
                        width: 100%;
										   
                        padding-right: 5px;		  
                        ul {
                            margin-left: 0;
                            margin-top: 0;
                            margin-bottom: 0;
                            width: 100%;
                            li {
                                display: flex;
                                padding-top: 14px;
                                padding-bottom: 14px;
                                padding-left: 7px;
                                line-height: 0;
                                list-style-type: none;
                                border-bottom: solid 2px ${ADIColors.gray7};
                                ${TypographyStyle} {
                                    font-size: 14px;
                                    font-weight: 600;
                                }
                            }
                        }
                    `,
                    css`
                        padding-left: 8px;
                        padding-right: 5px;
                        height: 100%;
                        ul {
                            li {
                                padding-bottom: 12px;
                                padding-left: 7px;
                            }
                        }
                    `,
                    null,
                    null,
                ]);
            }}
  .rd-customlink-list.tooltip-link {
                .rd-linklist-linkitem {
                    font-size: 16px;
            font-weight: bold;
        
                    line-height: normal;
                    white-space: nowrap;
                cursor: pointer;
                        color: ${getColor("primary")};
            :hover {
                text-decoration: underline;
            }
       
					${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 14px;
                        `,
                    css`
                        font-size: 14px;
                        `,
                    css`
                         font-size: 14px;
                        `,
                    null,
                    null,
                ])} 
                }
            }

            .tooltip-link {
                .tooltip-wrapper {
                    //position: absolute;
                    //right: -18px;
                    .tooltip-icon {
                        position: relative !important;
                        display: inline-block;
                        height: 17px;
                        width: 17px;
                        vertical-align: bottom;
                        font-style: normal;
                        margin-left: 24px;
                        vertical-align: middle;
                        padding-bottom: 5px;
                        margin-bottom: 0.25em;
                        ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [css` margin-left: 10px;
                                margin-top:2px`,
                                 css` margin-left: 10px;
                                margin-top:2px`,
                    css` margin-left: 10px;
                            margin-top:5px`
                    ,
                    css` margin-left: 10px;
                            margin-top:5px`
                    ,
                    css` margin-left: 10px;
                            margin-top:5px`
                    ,]);
            }}
                        &:after {
                            content: "";
                            position: absolute;
                            left: -17px;
                            right: -5px;
                            top: 2px;
                            //background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/tooltip_icon_default.svg);
                            background-repeat: no-repeat;
                            background-size: 17px 17px;
                            background-position: center;
                            height: 17px;
                            width: 17px;

                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        left: 10px;
                                        `,
                                    css`
                                        left: 10px;
                                        `,
                                    css`
                                        left: 10px;
                                        `,
                                    null,
                                    null,
                                ])} 
                        }

                        &.tooltip-active {
                            &:after {
                                content: "";
                                position: absolute;
                                left: -17px;
                                right: -5px;
                                top: 2px;
                                // background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/tooltip_icon_active.svg);
                                background-repeat: no-repeat;
                                background-size: 17px 17px;
                                background-position: center;
                                height: 17px;
                                width: 17px;
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        css`
                                            left: 10px;
                                            `,
                                        css`
                                            left: 10px;
                                            `,
                                        css`
                                            left: 10px;
                                            `,
                                        null,
                                        null,
                                    ])} 
                            }

                            .tooltip-text {
                                display: block;
                                margin: auto;
                                transform: translate(-51%, 2px);
                                ${({ theme }) => { return breakpointMediaQueries(
                                    theme, [null, null, 
                                    css` transform: translate(-42.5%, 2px);`
                                    ,],"max",); 
                                }}
                            }
                        }

                        .tooltip-text {
                            padding: 10px 15px;
                            border: 1px solid #bbb;
                            width: 277px;
                            border-radius: 5px;
                            margin-left: -158px;
                            top: auto;
                            bottom: 70px;
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            -webkit-letter-spacing: normal;
                            -moz-letter-spacing: normal;
                            -ms-letter-spacing: normal;
                            letter-spacing: normal;
                            text-align: left;
                            color: #2d2926;
                            display: none;
                            background: #ffffff;
                            position: relative;
                            left: 19px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        margin-left: -132px;
                                        left: 8px;
                                    bottom:87px;
                                        `,
                                    css`
                                        margin-left: -132px;
                                        left: 8px;
                                    bottom:87px;
                                        `,
                                    css`
                                        margin-left: -132px;
                                        left: 8px;
                                    bottom:87px;
                                        `,
                                    css` left: 35px;
                                    bottom:97px;`,
                                    css` left: 35px;
                                    bottom:97px;`,
                                ])} 
                            > a {
                                font-size: 14px;
                                font-weight: normal;
                                font-stretch: normal;
                                font-style: normal;
                                line-height: normal;
                                letter-spacing: normal;
                                color: #2d2926 !important;
                                text-decoration: underline !important;

                                &:hover {
                                    font-size: 14px;
                                    font-weight: normal;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: normal;
                                    letter-spacing: normal;
                                    color: #2d2926 !important;
                                }
                            }

                            &:before {
                                top: auto;
                                left: 125px;
                                bottom: -10px;
                                border-right: 10px solid transparent;
                                border-bottom: 10px solid #555;
                                border-left: 10px solid transparent;
                                border-bottom-color: #bbb;
                                transform: rotate(180deg);
                            }
                        }
                    }
                }
            }
            .tooltip-icon .tooltip-text:after {
                content: "";
                position: absolute;
                left: calc(50% - 32px);
                bottom: auto;
                top:85%;
                border: 8px solid #fff;
                box-shadow: -1px 1px 0 0 #bbb;
                border-color: transparent transparent #fff #fff;
                -webkit-transform: rotate(315deg);
                -ms-transform: rotate(315deg);
                transform: rotate(315deg);
            }
            .tooltip-wrapper .tooltip-icon .tooltip-text > a span {
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #2d2926 !important;
                text-decoration: underline !important;
            }

            @media only screen and (max-width: 767px) {
                .rd-customlink-list.tooltip-link .rd-linklist-linkitem {
                    margin-top: 0px;
                }
                .tooltip-wrapper {
                    position: unset !important;
                    left: unset !important;
                }
            }
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
                #myAccountLandingDiv .tooltip-link .tooltip-wrapper .tooltip-icon {
                    margin-left: 2px;
                }
            }
        `,
    },
    rightContentLink: {
        css: css`
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: ${getColor("primary")};
            :hover {
                text-decoration: underline;
            }
			${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 14px;
                        `,
                    css`
                        font-size: 14px;
                        `,
                    css`
                         font-size: 14px;
                        `,
                    null,
                    null,
                ])}
			`,
    },
    modal: {
        size: 600,
        cssOverrides: {
            modalBody: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius: 0px;
                        `,
                        css`
                            border-radius: 0px;
                        `,
                        css`
                            border-radius: 0px;
                        `,
                        css`
                            border-radius: 10px;
                        `,
                        css`
                            border-radius: 10px;
                        `,
                    ])}
            `,
            modalTitle: css`
                padding: 10px 30px;
                padding-top: 15px;
                border-bottom: 0px;
                > ${ButtonWrapper} {
                    position: relative;
                    left: 15px;
                    :hover {
                        background: none;
                        border-color: transparent;
                    }
                    > ${IconWrapper} {
                        height: 45px;
                        width: 45px;
                        color: ${getColor("primary")};

                        > svg {
                            height: 45px;
                            width: 45px;
                        }
                    }
                }
                > ${TypographyStyle} {
                    font-size: 2rem;
                }
            `,
            modalContent: css`
                padding: 20px 30px;
                padding-top: 0px;
                padding-bottom: 30px;
                margin-top: -10px;
            `,
        },
    },
};

const styles = adiMyAccountStyles;

interface LeftContentProps {
    link?: string;
    src: string | ComponentType<{}> | undefined;
    title: string;
    handleRedirect?: () => void;
}

const LeftContent: FC<LeftContentProps> = ({ link, handleRedirect, src, title }) => {
    return (
        <StyledWrapper {...styles.leftContentHidden}>
            <Hidden below="md" {...styles.leftContentHidden}>
                {link && (
                    <Link href={link} {...styles.leftcontent}>
                        <Icon src={src} {...styles.leftContentIcon}></Icon>
                        <StyledWrapper {...styles.leftContentTextWrapper}>
                            <Typography {...styles.leftContentText}>{title}</Typography>
                        </StyledWrapper>
                    </Link>
                )}
                {handleRedirect && (
                    <Link onClick={handleRedirect} {...styles.leftcontent}>
                        <Icon src={src} {...styles.leftContentIcon}></Icon>
                        <StyledWrapper {...styles.leftContentTextWrapper}>
                            <Typography {...styles.leftContentText}>{title}</Typography>
                        </StyledWrapper>
                    </Link>
                )}
                {!handleRedirect && !link && (
                    <StyledWrapper {...styles.leftcontent}>
                        <Icon src={src} {...styles.leftContentIcon}></Icon>
                        <StyledWrapper {...styles.leftContentTextWrapper}>
                            <Typography {...styles.leftContentText}>{title}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                )}
            </Hidden>
            <Hidden above="sm">
                <StyledWrapper {...styles.leftcontentMobile}>
                    <Icon src={src} {...styles.leftContentIconMobile}></Icon>
                    <StyledWrapper {...styles.leftContentTextWrapperMobile}>
                        <Typography {...styles.leftContentTextMobile}>{title}</Typography>
                        {handleRedirect && (
                            <Link onClick={handleRedirect} {...styles.leftContentTextMobile}>
                                <Typography>{translate("View All")}</Typography>
                            </Link>
                        )}
                        {link && (
                            <Link href={link} {...styles.leftContentTextMobile}>
                                <Typography>{translate("View All")}</Typography>
                            </Link>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            </Hidden>
        </StyledWrapper>
    );
};

interface RightContentProps {
    children?: React.ReactNode;
}

const RightContent: FC<RightContentProps> = ({ children }) => {
    return (
        <StyledWrapper {...styles.rightcontent}>
            <ul>{children}</ul>
        </StyledWrapper>
    );
};

interface AccountLinkTextAndFuncProps {
    href?: string;
    target?: string;
    title: string;
    tooltip?: string;
    handleModel?: () => void;
}

const AccountLinkTextAndFunc: FC<AccountLinkTextAndFuncProps> = ({ href, target, title, tooltip, handleModel }) => {
    return (
        <li>
            {href && (
                <Link {...styles.rightContentLink} href={href} target={target}>
                    {title}
                </Link>
            )}
            {handleModel && (
                <Link {...styles.rightContentLink} onClick={handleModel}>
                    {title}
                </Link>
            )}
        </li>
    );
};

export const isProductInventoryOnlyRole = (roles: any): boolean => {
    var isPIO = false;
    if (roles) {
        var arrUserRoles = roles.split(",");
        var isPIO = false;
        if (
            (arrUserRoles.length == 1 && arrUserRoles[0].trim() == "ProductInventoryOnly") ||
            (arrUserRoles.length == 2 &&
                arrUserRoles[0].trim() == "ProductInventoryOnly" &&
                arrUserRoles[1].trim() == "NationalInventory") ||
            (arrUserRoles.length == 2 &&
                arrUserRoles[1].trim() == "NationalInventory" &&
                arrUserRoles[0].trim() == "ProductInventoryOnly")
        ) {
            isPIO = true;
        }
    }
    return isPIO;
};

export const priceForPIORole = (catalogSettings: any): any => {
    var priceSettingForPIORole = catalogSettings.priceForPIORole;
    return priceSettingForPIORole;
};

export const defaultWarehouse = (catalogSettings: any): any => {
    return catalogSettings.defaultWarehouse;
};

export const defaultWarehouseDisplayName = (catalogSettings: any): any => {
    return catalogSettings.defaultWarehouseDisplayName;
};

const ADIMyAccount: FC<Props> = ({ history, session, userRoles, customerNumber }) => {
    const [pathfr, setpathFr] = useState("");
    const [openChangePasswordPopup, setOpenChangePasswordPopup] = useState(false);
    const handleCloseChangePasswordPopup = () => setOpenChangePasswordPopup(false);
    const handleOpenChangePasswordPopup = () => setOpenChangePasswordPopup(true);
    const handleModalIsClose = () => setModalIsOpen(false);
    const handleThankPopOpen = () => setModalIsOpen(true);

    const [openPickUpNotificationPopup, setOpenPickUpNotificationPopup] = useState(false);

    const handleClosePickUpNotificationPopup = () => setOpenPickUpNotificationPopup(false);
    const handleOpenPickUpNotificationPopup = () => setOpenPickUpNotificationPopup(true);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const redirectToOrder = () => history.push("/MyAccount/Order");

    const redirectToQuotes = () => history.push("/MyAccount/MyQuotes");
    const redirectTorequestQuote = () => history.push("/MyAccount/RequestQuoteForm");

    const redirectToAddaNewUser = () => history.push("/MyAccount/addnewuser");

    const [isMobile, setIsMobile] = React.useState(false);

    useEffect(() => {
        setpathFr(window.location.href.toString());
    }, []);

    React.useEffect(() => {
        if (!window) return;
       const onWindowResize = () => {
            if (window.innerWidth <= 767) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };
        onWindowResize();
    }, []);

    const isus = pathfr.includes(".us") || containsPortNumber(pathfr);

    const ispr=pathfr.includes(".pr");

    const isProductInventoryOnlyRoleValue = userRoles.productInventoryOnly;

    const isFullAccess = userRoles.fullAccess;

    const hasSuffixZero = customerNumber?.split("-")[0]===customerNumber?.split("-")[1];

    const isFullAccessOrIsLimitedAccess = userRoles.fullAccess || userRoles.limitedAccess;

    const isFullAccessAndIsAccounting = userRoles.fullAccess && userRoles.accounting;

    const isFullAccessOrIsLimitedAccessAndAccounting =
        (userRoles.fullAccess || userRoles.limitedAccess) && userRoles.accounting;

    const isFullAccessOrIsLimitedAccessAndAccountingOrEmployee =
        ((userRoles.fullAccess || userRoles.limitedAccess) && userRoles.accounting) || userRoles.employee;

    const isFullAccessOrIsLimitedAccessAndisus = (userRoles.fullAccess || userRoles.limitedAccess) && isus;

    const [ishover, setishover] = useState(false);

    const tooltipUpdate = () => {
        setishover(true);
    };

    const tooltipDisable = () => {
        setishover(false);
    };
    const customerSettings = useSelector((state: ApplicationState) => getSettingsCollection(state).customerSettings);
    const enableAdiXtenIntegration = customerSettings.enableAdiXtenIntegration;
    const allowedUserRole = customerSettings.allowedUserRole;
    const allowRMASubmission =customerSettings.allowRMASubmission;
    return (
        <>
            <StyledWrapper>
                <GridContainer {...styles.myaccountGridContainer}>
                    {/* MY Account */}
                    <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                        <LeftContent src={Settings} title={translate("Account Settings")} />
                        <RightContent>
                            <AccountLinkTextAndFunc
                                title={translate("Change Password")}
                                handleModel={handleOpenChangePasswordPopup}
                            />
                            <AccountLinkTextAndFunc
                                title={translate("Email Preferences")}
                                href="https://go.adiglobal.com/preferences.html"
                                target="_blank"
                            />
                            {!isProductInventoryOnlyRoleValue && (
                                <AccountLinkTextAndFunc
                                    title={translate("Pickup Notifications")}
                                    handleModel={handleOpenPickUpNotificationPopup}
                                />
                            )}

                            {isFullAccess &&
                                <Typography as="li" className="rd-customlink-list tooltip-link">
                                    <Typography as="span" className="rd-linklist-linkitem"
                                        onClick={redirectToAddaNewUser}>
                                        Add a New User
                                    </Typography>
                                    <Typography as="span" className="tooltip-wrapper">
                                        <Typography
                                            onMouseEnter={tooltipUpdate}
                                            onMouseLeave={tooltipDisable}
                                            className={ishover ? "tooltip-icon tooltip-active" : "tooltip-icon"}
                                        >   
                                            {!ishover ? <RewardsTooltipIconForAcc /> : <LazyImage
                                                src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/newicons/tooltip_icon_active.svg"
                                                width="15px"
                                                height="15px"

                                            />}

                                            <Typography as="span" className="tooltip-text">
                                                {translate("To delete users to your account, please call Web Support at ")}
                                                <Link href="tel:1.877.228.6739"> 1.877.228.6739</Link>
                                            </Typography>
                                        </Typography>
                                    </Typography>
                                </Typography>
                            }
                        </RightContent>
                    </GridItem>
                    {/* MY Order */}
                    {isFullAccessOrIsLimitedAccess && (
                        <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                            <LeftContent
                                src={MyOrder}
                                title={translate("My Orders")}
                                handleRedirect={redirectToOrder}
                            />
                            <RightContent>
                                <AccountLinkTextAndFunc
                                    title={translate("View Orders")}
                                    handleModel={redirectToOrder}
                                />
                                {/* This is Sprint 7. Uncomment this link in Sprint 7 when the page is created. */}
                                {/* as per ADINA-57009, link should be visible for PR & CS sites only not US since page is not developed*/}
                                {/* {isFullAccessAndIsAccounting && (
                                    <AccountLinkTextAndFunc
                                        title={translate("Spend Analytics Report")}
                                        target="_blank"
                                        href="/reports/customerSalesReportSample.html"
                                    />
                                )} */}
                            </RightContent>
                        </GridItem>
                    )}

                    {/* MY Quotes */}
                    {isFullAccessOrIsLimitedAccess && (
                        <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                            <LeftContent
                                src={MyQuotes}
                                title={translate("My Quotes")}
                                handleRedirect={redirectToQuotes}
                            />
                            <RightContent>
                                <AccountLinkTextAndFunc
                                    title={translate("View Quotes")}
                                    handleModel={redirectToQuotes}
                                />
                                <AccountLinkTextAndFunc
                                    title={translate("Request Quote")}
                                    handleModel={redirectTorequestQuote}
                                />
                            </RightContent>
                        </GridItem>
                    )}

                    {/* MY Billing */}
                    {isFullAccessOrIsLimitedAccessAndAccounting && (
                        <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                            <LeftContent src={Billing} title={translate("Billing")} />
                            <RightContent>
                                {isFullAccessOrIsLimitedAccessAndAccountingOrEmployee && (
                                    <AccountLinkTextAndFunc title={translate("Invoices")} href="/MyAccount/Invoices" />
                                )}
                                {isFullAccessOrIsLimitedAccessAndAccounting && hasSuffixZero && (
                                    <AccountLinkTextAndFunc
                                        title={translate("Statements")}
                                        href="/MyAccount/ViewStatements"
                                    />
                                )}
                            </RightContent>
                        </GridItem>
                    )}

                    {/* Ordering Tools */}
                    {isFullAccess && (
                        <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                            <LeftContent src={OrderingTools} title={translate("Ordering Tools")} />
                            <RightContent>
                                <AccountLinkTextAndFunc title={translate("My Lists")} href="/myaccount/mylists" />
                                {session.properties.priceList_Flg === "Y" && !isMobile && (
                                    <AccountLinkTextAndFunc
                                        title={translate("Price List Request")}
                                        href="/MyAccount/PriceListRequest"
                                    />
                                )}
                                <AccountLinkTextAndFunc title={translate("Quick Order")} href="/MyAccount/Quickorder" />
                                <AccountLinkTextAndFunc
                                    title={translate("Recently Purchased Products")}
                                    href="/MyAccount/RecentlyPurchasedProducts"
                                />
                            </RightContent>
                        </GridItem>
                    )}

                {/* Returns */}
                {isFullAccessOrIsLimitedAccess && allowRMASubmission && (
                    <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                        <LeftContent src={Returns} title={translate("Returns")} />
                        <RightContent>
                            {<AccountLinkTextAndFunc
                                title={translate("Return Status")}
                                href="/MyAccount/Returns/ReturnHistory"
                            />}
                            
                            <AccountLinkTextAndFunc
                                title={translate("Start a Return")}
                                href="/MyAccount/Returns/SelectOrders"
                            /> 
                            <AccountLinkTextAndFunc title={translate("Returns Help")} href="/returns" />
                        </RightContent>
                    </GridItem>
                )}

                    {/* Promos & Deals */}
                    <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                        <LeftContent src={PromoAndDeals} title={translate("Promos & Deals")} />
                        <RightContent>
                            <AccountLinkTextAndFunc
                                title={translate("Sale Center")}
                                href="/Catalog/savings/sale-center"
                            />
                            <AccountLinkTextAndFunc
                                title={translate("Clearance Zone")}
                                href="/Catalog/savings/clearance-zone"
                            />
                            { !ispr &&( <AccountLinkTextAndFunc title={translate("SPIFFs")} href="/spiffs" />)}
                        </RightContent>
                    </GridItem>

                    {/* Help */}
                    <GridItem width={[12, 12, 6, 6, 4]} {...styles.myaccountGridItem}>
                        <LeftContent src={Help} title={translate("Help")} />
                        <RightContent>
                            <AccountLinkTextAndFunc title={translate("Website Support")} href="/website-help" />
                            <AccountLinkTextAndFunc
                                title={translate("Ordering & Invoices")}
                                href="/ordering-invoices"
                            />
                            <AccountLinkTextAndFunc
                                title={translate("Shipping & Pickup")}
                                href="/shipping-and-pickup"
                            />
                        </RightContent>
                    </GridItem>
                    {enableAdiXtenIntegration && IsXtenAllowedUser(allowedUserRole) && (
                        <GridItem width={[12, 12, 6, 6, 6]} {...styles.myaccountGridItem}>
                            <LeftContent src={PromoAndDeals} title={translate("XTEN-AV")} />
                            <RightContent>
                                 <ADIXtenExportToXtenButton
                                    id="xdoc"
                                    type="xdoc"
                                    buttonText={translate("X-Doc - Create a Proposal")}
                                />
                            </RightContent>
                        </GridItem>
                    )}

                </GridContainer>

                {/* Modals */}
                <ADIChangePasswordModalWrapper
                    isOpen={openChangePasswordPopup}
                    handleClose={handleCloseChangePasswordPopup}
                    headline={translate("Change Password")}
                    errorStyle={false}
                >
                    <ADIChangePassword
                        handleClose={handleCloseChangePasswordPopup}
                        handlePopupOpen={handleThankPopOpen}
                    />
                </ADIChangePasswordModalWrapper>

                <ADIPickUpNotificationModalWrapper
                    isOpen={openPickUpNotificationPopup}
                    handleClose={handleClosePickUpNotificationPopup}
                    headline={translate("Pickup Notifications")}
                    subheading={translate(
                        "Would you like to be emailed when products in your order are ready for pickup?",
                    )}
                    errorStyle={false}
                >
                    <ADIPickUpNotification handleClose={handleClosePickUpNotificationPopup} />
                </ADIPickUpNotificationModalWrapper>
            </StyledWrapper>
            <Modal
                {...styles.modal}
                headline={translate("Thank You")}
                isOpen={modalIsOpen}
                handleClose={handleModalIsClose}
            >
                <Typography>{translate("Your password has been reset.")}</Typography>
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(ADIMyAccount)),
    definition: {
        group: "My Account",
        displayName: "ADI My Account",
    },
};

export default widgetModule;
